function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0757 35.8496L49.9305 33.0268L54.1683 32.4872L55.9357 28.6643L57.7032 32.4872L61.9403 33.0268L58.795 35.8496L59.6465 40.0853L55.9357 37.9282L52.2243 40.0853L53.0757 35.8496Z",
  fill: "black"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0757 21.5237L49.9305 18.7002L54.1683 18.1612L55.9357 14.3376L57.7032 18.1612L61.9403 18.7002L58.795 21.5237L59.6465 25.7587L55.9357 23.6016L52.2243 25.7587L53.0757 21.5237Z",
  fill: "black"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M53.0757 7.19709L49.9305 4.37353L54.1683 3.83461L55.9357 0.0110016L57.7032 3.83461L61.9403 4.37353L58.795 7.19709L59.6465 11.4321L55.9357 9.27499L52.2243 11.4321L53.0757 7.19709Z",
  fill: "black"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M58.3647 52.114L43.1376 35.022C41.052 38.6886 37.9873 41.7266 34.2976 43.7758L51.4351 59.0436C52.9461 60.3899 55.2447 60.3233 56.6758 58.8922L58.2141 57.3539C59.6444 55.9236 59.711 53.6249 58.3647 52.114Z",
  fill: "black"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M19.015 14.1344C19.015 10.0424 20.1293 9.33176 22.7658 9.33176C25.4022 9.33176 26.5466 10.0634 26.5452 14.1344C26.5438 16.946 25.1247 19.5902 22.7391 19.5902C20.4075 19.5902 19.015 17.6118 19.015 14.1344Z",
  fill: "black"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.2892 45.2573C9.99913 45.2573 0 35.2582 0 22.9681C0 10.678 9.99913 0.679573 22.2892 0.679573C34.5793 0.679573 44.5784 10.6787 44.5784 22.9688C44.5784 35.2589 34.5793 45.2573 22.2892 45.2573ZM22.2892 6.54464C13.2334 6.54464 5.86577 13.9122 5.86577 22.9681C5.86577 32.0239 13.2334 39.3915 22.2892 39.3915C31.3451 39.3915 38.7127 32.0239 38.7127 22.9681C38.7127 13.9122 31.3451 6.54464 22.2892 6.54464Z",
  fill: "black"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M29.9603 20.9897L27.1991 20.9547L24.1877 26.4749L23.7889 23.6829L24.255 22.7508C24.761 21.7389 24.0651 20.9547 23.5899 20.9547H21.9416C21.4672 20.9547 20.7706 21.7389 21.2765 22.7508L21.7426 23.6829L21.3438 26.4749L18.3324 20.9547L15.3547 20.9729C13.6532 20.9708 12.3489 21.9884 12.1948 23.6829V33.1494C14.7892 35.7214 18.3556 37.3143 22.2885 37.3143C26.7197 37.3143 30.6863 35.2932 33.3199 32.1263L33.3361 23.6822C33.1314 22.0381 31.617 20.9911 29.9603 20.9897Z",
  fill: "black"
});

var SvgСandidates = function SvgСandidates(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 62,
    height: 61,
    viewBox: "0 0 62 61",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgСandidates, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/сandidates.526aca47.svg";
export { ForwardRef as ReactComponent };